import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d28a2f8")

_pushScopeId("data-v-1d28a2f8")
const _hoisted_1 = { class: "sharing-button" }
const _hoisted_2 = { class: "wrap-button" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_PopUpWithButton = _resolveComponent("PopUpWithButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.sharingState.isSharing)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          class: "sharing_border",
          size: "l",
          mode: "flat",
          iconOnly: "",
          icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic25-sharing-on', color: '--sui-gray-700', width: '25px', height: '25px'},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleScreenSharing('none')))
        }, null, 8, ["icon"]))
      : (_openBlock(), _createBlock(_component_PopUpWithButton, {
          key: 1,
          class: "sharing",
          name: "ic25-sharing-off",
          size: "25px",
          buttonMode: "secondary"
        }, {
          content: _withId(() => [
            _createVNode("div", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sharingButtons, (item) => {
                return (_openBlock(), _createBlock(_component_Button, {
                  class: "item",
                  mode: "flat",
                  size: "l",
                  onClick: ($event: any) => (_ctx.toggleScreenSharing(item.type)),
                  icon: { spriteUrl: '/image/videoconf-icons.svg', name: item.icon, color: '--sui-gray-700', width: '25px', height: '25px'}
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "icon"]))
              }), 256))
            ])
          ]),
          _: 1
        }))
  ]))
})